import _ from 'lodash';
import React from 'react';
import Warning from '@material-ui/icons/Warning';
import LockIcon from '@material-ui/icons/LockOpen';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import momentTz from 'moment-timezone';
import { GREEN, MATCH_TAG_MODE, ORANGE, PERMISSIONS, PERMISSION_ENTITIES } from '../../../_config/consts.js';
import { isLockSupportingPIN } from '../../../_config/utils.js';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider.js';
import TimezoneIconCustom from '../../CustomIcons/TimezoneIconCustom.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import TagsSelectorListField from '../Elements/TagsSelectorListField.jsx';
import SelectableRowField from '../Fields/SelectableRows/SelectableRowField.jsx';
import MDCheckBoxField from '../Fields/MDCheckBox/MDCheckBoxField.js';
import MDSwitchView from '../Fields/MDSwitch/MDSwitchView.jsx';
import SelectableField from '../Fields/SelectableInput/SelectableField.jsx';
import CustomField from '../Fields/CustomField.jsx';

const validate = values => {
  const errors = {};

  if (!values.business) {
    errors.business = 'required';
  }

  if (!values.pin && !values.credentialRule && !values.invitation) {
    errors.pin = 'required';
    errors.credentialRule = 'required';
    errors.invitation = 'required';
  }

  if (values.preCheckinEnabled && (!values.lockTags || !values.lockTags.length)) {
    errors.lockTags = 'required';
  }

  return errors;
};

@reduxForm({ form: 'MewsSelectEnterpriseForm', validate })
@connect(state => ({ form: state.form.MewsSelectEnterpriseForm }))
class MewsSelectEnterpriseForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      timezones: momentTz.tz.names(),
      guessedTimezone: momentTz.tz.guess(),
      showTimezoneSelector: false,
    };
  }

  componentDidMount() {
    const { guessedTimezone } = this.state;
    const { dispatch } = this.props;
    dispatch(change('MewsSelectEnterpriseForm', 'timezone', guessedTimezone));
    dispatch(change('MewsSelectEnterpriseForm', 'reservationsDaysBefore', 0));
    dispatch(change('MewsSelectEnterpriseForm', 'reservationsDaysAfter', 0));
    dispatch(change('MewsSelectEnterpriseForm', 'preCheckinEnabled', true));
    dispatch(change('MewsSelectEnterpriseForm', 'preCheckinCleanupEnabled', true));
    dispatch(change('MewsSelectEnterpriseForm', 'ignoreFlagOwnerCheckedIn', true));
    dispatch(change('MewsSelectEnterpriseForm', 'lockTagMatchingMode', MATCH_TAG_MODE.AT_LEAST_ONE_TAG));
  }

  onFilterTimezones(value) {
    const timezones = momentTz.tz.names().filter(timezone => timezone.toLowerCase().includes(value.toLowerCase()));
    this.setState({ timezones });
  }

  onSelectTimezone(selectedOption) {
    const { dispatch } = this.props;
    const selectedTimezone = selectedOption && selectedOption.value ? selectedOption.value : momentTz.tz.guess();
    dispatch(change('MewsSelectEnterpriseForm', 'timezone', selectedTimezone));
    this.setState({ guessedTimezone: selectedTimezone });
  }

  render() {
    const {
      enterprises,
      availableLockTags,
      locksFilteredByTags,
      form,
      onFetchMoreLocks,
      onLockTagsChange,
      onLockInputChange,
      onLockFilterModeChange,
    } = this.props;
    const { guessedTimezone, showTimezoneSelector, timezones } = this.state;
    const preCheckinEnabled = form && form.values && form.values.preCheckinEnabled;
    const canReadLock = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.SMART_LOCK);
    const locksHaveError = locksFilteredByTags && locksFilteredByTags[0] && locksFilteredByTags[0].data
      ? _.find(locksFilteredByTags[0].data, smartLock => !isLockSupportingPIN(smartLock))
      : false;

    const enterprisesOptions = _.map(enterprises, enterprise => ({
      name: enterprise.name,
      id: enterprise.id,
      type: { name: 'Enterprise' },
    }));

    return (
      <div>
        <h4 style={{ color: '#3f3f3f', textAlign: 'start', marginTop: 10, marginBottom: 20, fontWeight: 'bold' }}>
          <Entity entity="mewsSelectPropertiesTitle" />
        </h4>
        <Field
          name="enterprises"
          component={SelectableRowField}
          options={{
            content: enterprisesOptions,
          }}
          listContainerStyle={{ marginTop: 0 }}
          listStyle={{ marginTop: 0 }}
        />
        <h4 style={{ color: '#3f3f3f', fontWeight: 'bold', fontSize: 20, marginTop: 30, marginBottom: 10 }}>
          <Entity entity="integrationSettingsParameters" />
        </h4>
        <FormFlatContainer
          title="mewsSyncModeTitle"
          subtitle="synchronizeReservationsAsChoose2"
          containerStyle={{ marginRight: 0 }}
        >
          <Field
            name="pin"
            label={<Entity entity="synchronizeReservationsAsPinsTitle" style={{ color: '#3f3f3f' }} />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 20, marginTop: -10, color: '#3f3f3f' }}>
            <Entity entity="synchronizeReservationsAsPins" />
          </h5>
          <Field
            name="credentialRule"
            label={<Entity entity="synchronizeReservationsAsCredentialRulesTitle" style={{ color: '#3f3f3f' }} />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 20, marginTop: -10, color: '#3f3f3f' }}>
            <Entity entity="synchronizeReservationsAsCredentialRules" />
          </h5>
          <Field
            name="invitation"
            label={<Entity entity="synchronizeReservationsAsInvitationsTitle" style={{ color: '#3f3f3f' }} />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 10, marginTop: -10, color: '#3f3f3f' }}>
            <Entity entity="synchronizeReservationsAsInvitations" />
          </h5>
        </FormFlatContainer>
        <FormFlatContainer
          title="mewsTimezoneAndDaysTitle"
          subtitle="mewsTimezoneAndDaysSubtitle"
          containerStyle={{ marginTop: 20, marginRight: 0 }}
        >
          {guessedTimezone ? (
            <div>
              <h4 style={{ fontWeight: 'bold', fontSize: 16, marginTop: 0 }}>
                <Entity entity="buildingTimeZone" />
              </h4>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 10, paddingLeft: 15, borderRadius: 10, background: '#f0f0f0' }}>
                <TimezoneIconCustom style={{ width: 20, marginRight: 10 }} />
                <h5 style={{ fontWeight: 'bold', fontSize: 16 }}>{guessedTimezone}</h5>
              </div>
              <MDSwitchView
                label={<Entity key={showTimezoneSelector} entity="notYourTimeZone" />}
                checked={showTimezoneSelector}
                titleStyle={{ fontWeight: showTimezoneSelector ? 'bold' : 'normal', color: showTimezoneSelector ? GREEN : '#3f3f3f' }}
                onSelect={selected => this.setState({ showTimezoneSelector: selected })}
              />
            </div>
          ) : null}
          {showTimezoneSelector ? (
            <Field
              name="timezone"
              title={<Entity entity="selectTimezone" />}
              component={SelectableField}
              options={_.map(timezones, timezone => ({ value: timezone, label: timezone }))}
              titleStyle={{ fontSize: 16 }}
              placeholder={<Entity entity="search" />}
              containerstyle={{ width: '100%', marginBottom: 20 }}
              onInputChange={value => this.onFilterTimezones(value)}
              onSelect={value => this.onSelectTimezone(value)}
            />
          ) : null}
          <Entity
            name="reservationsDaysBefore"
            componentClass={Field}
            componentAttribute="placeholder"
            entity="mewsReservationsDaysBeforePlaceholder"
            title={<Entity entity="mewsReservationsDaysBefore" />}
            type="number"
            component={CustomField}
            containerStyle={{ marginTop: 10 }}
          />
          <Entity
            name="reservationsDaysAfter"
            componentClass={Field}
            componentAttribute="placeholder"
            entity="mewsReservationsDaysAfterPlaceholder"
            title={<Entity entity="mewsReservationsDaysAfter" />}
            type="number"
            component={CustomField}
            containerStyle={{ marginTop: 10 }}
          />
        </FormFlatContainer>
        <FormFlatContainer
          title="mewsPreCheckinTitle"
          subtitle="mewsPreCheckinSubtitle"
          containerStyle={{ marginTop: 20, marginRight: 0 }}
          icon={<LockIcon style={{ fontSize: 22, marginTop: 2, marginRight: 2 }} />}
        >
          <Field
            name="preCheckinEnabled"
            label={<Entity entity="mewsPreCheckinEnabled" style={{ color: '#3f3f3f' }} />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 20, marginTop: -10, color: '#3f3f3f' }}>
            <Entity entity="mewsPreCheckinEnabledDescription" />
          </h5>
          {preCheckinEnabled ? (
            <div>
              <TagsSelectorListField
                formName="MewsSelectEnterpriseForm"
                name="lockTags"
                selectorFieldName="lockTagMatchingMode"
                selectedTagsFieldName="selectedLocksTags"
                tags={(availableLockTags || []).filter(e => e.type !== 'private_unit')}
                selectedTags={locksFilteredByTags && locksFilteredByTags[0]}
                form={form}
                tagsType="LOCK"
                title="lockTags"
                placeholder="insertLockTagsForPrivateUnit"
                listTitle="selectedLocks"
                emptyTagSelectionText={canReadLock ? 'noLocksSelectedWithTag' : null}
                onFetchMoreItems={page => onFetchMoreLocks(page)}
                onTagsChange={values => onLockTagsChange(values)}
                onInputChange={value => onLockInputChange(value)}
                onFilterModeChange={value => onLockFilterModeChange(value)}
                itemHasErrorCondition={lock => !isLockSupportingPIN(lock)}
                isOptional={false}
              />
              {locksHaveError ? (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
                  <Warning style={{ color: ORANGE, marginRight: 5, fontSize: 20 }} />
                  <h5 style={{ color: ORANGE, fontWeight: 'bold', margin: 0 }}>
                    <Entity entity="selectedLocksPINIncompatibleError" />
                  </h5>
                </div>
              ) : null}
            </div>
          ) : null}
        </FormFlatContainer>
        <FormFlatContainer
          title="mewsCleanupAndColdStartTitle"
          subtitle="mewsCleanupAndColdStartSubtitle"
          containerStyle={{ marginTop: 20, marginRight: 0 }}
        >
          <Field
            name="preCheckinCleanupEnabled"
            label={<Entity entity="mewsPreCheckinCleanupEnabled" style={{ color: '#3f3f3f' }} />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 20, marginTop: -10, color: '#3f3f3f' }}>
            <Entity entity="mewsPreCheckinCleanupEnabledDescription" />
          </h5>
          <Field
            name="ignoreFlagOwnerCheckedIn"
            label={<Entity entity="mewsIgnoreFlagOwnerCheckedIn" style={{ color: '#3f3f3f' }} />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 20, marginTop: -10, color: '#3f3f3f' }}>
            <Entity entity="mewsIgnoreFlagOwnerCheckedInDescription" />
          </h5>
          <Field
            name="coldStartResources"
            label={<Entity entity="synchronizeAllResource" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 10, marginTop: -10, color: '#3f3f3f' }}>
            <Entity entity="synchronizeAllResourcesWhenActivate" />
          </h5>
        </FormFlatContainer>
      </div>
    );
  }
}

export default MewsSelectEnterpriseForm;
